if (!window.dpmQuickAddIconSync) {
  window.dpmQuickAddIconSync = true;

  const wrappers = (attribute, value) =>
    document.querySelectorAll(
      value ? `.quick-add-icon-wrapper[${attribute}="${value}"]` : `.quick-add-icon-wrapper[${attribute}]`
    );

  // The cart drawer returns focus to the element that opened it; if that
  // "+" is about to disappear, hand focus back to the card's title instead.
  const hide = (el) => {
    if (el.hidden) return;
    const drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.activeElement && el.contains(drawer.activeElement)) {
      const title = el.closest('.card-wrapper')?.querySelector('.card__heading a');
      if (title) drawer.setActiveElement(title);
    }
    el.hidden = true;
  };

  const syncWithCart = (items) => {
    const inCart = new Set(items.map((item) => String(item.product_id)));
    wrappers('data-product-id').forEach((el) => {
      if (inCart.has(el.dataset.productId)) hide(el);
      else el.hidden = false;
    });
  };

  // Full cart states (cart/change) carry item_count; an add response is only
  // the added line item(s), so it can hide but must never un-hide.
  subscribe(PUB_SUB_EVENTS.cartUpdate, ({ cartData } = {}) => {
    if (!cartData) return;
    if (Array.isArray(cartData.items) && 'item_count' in cartData) {
      syncWithCart(cartData.items);
      return;
    }
    const added = Array.isArray(cartData.items) ? cartData.items : [cartData];
    added.forEach((item) => {
      if (item && item.product_id) wrappers('data-product-id', item.product_id).forEach(hide);
    });
  });

  // A rejected add (sold since the page loaded, or already in the cart from
  // another tab) would otherwise just flash the spinner and do nothing.
  subscribe(PUB_SUB_EVENTS.cartError, ({ productVariantId } = {}) => {
    const matches = productVariantId ? Array.from(wrappers('data-variant-id', productVariantId)) : [];
    if (!matches.length) return;
    fetch(`${window.routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cart) => {
        const inCart = cart.items.some((item) => String(item.variant_id) === String(productVariantId));
        matches.forEach((el) => (inCart ? hide(el) : (el.dataset.state = 'sold')));
      })
      .catch(() => {});
  });

  // Pages restored from the back/forward cache keep their old markup.
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    fetch(`${window.routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cart) => syncWithCart(cart.items))
      .catch(() => {});
  });
}
